/* eslint-disable max-len */
import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context'
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { dataModelRelatedSearch, propTypesRelatedSearch } from './constants'; 
import { RelatedSearchLinks } from '../subcomponents/RelatedSearchLinks';
import { RelatedSearchPlaceholder } from './RelatedSearchPlaceholder';
import { useRelatedSearchData } from '../../hooks/useRelatedSearchData';

const RelatedSearchComponent = ({
  itemId,
  navParam: propNavParam,
  storeId,
  searchData: searchDataProps = {},
  keyword: propKeyword,
}) => {
  const { customContext } = useContext(ExperienceContext);
  const variables = customContext?.variables || {};
  const { navParam: contextNavParam = null, keyword: contextKeyword = null, storeId: contextStoreId = null } = variables || {};
  const navParam = propNavParam || contextNavParam;
  const resolvedKeyword = propKeyword ? decodeURIComponent(propKeyword) : contextKeyword;
  const resolvedStoreId = storeId || contextStoreId;
  const propsKeywordOrStoreId = propKeyword || storeId;

  const { relatedKeywords, loading, error } = useRelatedSearchData({
    itemId,
    navParam,
    storeId: resolvedStoreId,
    searchDataProps,
    keyword: resolvedKeyword ? resolvedKeyword : null,
    propsKeywordOrStoreId
  });

  useEffect(() => {
    window?.LIFE_CYCLE_EVENT_BUS?.lifeCycle?.trigger('related-search.ready')
  }, []);

  if (loading) return (<RelatedSearchPlaceholder />);

  if ((error && !relatedKeywords) || !relatedKeywords || relatedKeywords.length === 0) return null;

  const searchImpressionContainer = {
    id: '',
    component: 'RelatedSearch',
    name: 'RelatedSearch',
    type: 'content'
  };

  return (
    <ImpressionProvider data={searchImpressionContainer}>
      <div className="sui-flex sui-flex-col sui-w-full sui-gap-8" data-component="RelatedSearch">
        <RelatedSearchLinks relatedLinks={relatedKeywords} />
      </div>
    </ImpressionProvider>
  );
};

RelatedSearchComponent.displayName = 'RelatedSearch';

RelatedSearchComponent.propTypes = propTypesRelatedSearch;

RelatedSearchComponent.dataModel = dataModelRelatedSearch;

export { RelatedSearchComponent };